import React from 'react';
import { Box, Typography } from '@material-ui/core';
import StarIcon from '@material-ui/icons/Star';
import { useIntl } from 'react-intl';
import { makeStyles } from '@material-ui/core/styles';
import { useMfwThemeProvider } from 'myfitworld-utils';
import contentMessages from 'src/pages/content/messages';
import pageMessages from 'src/pages/messages';
import { SwitchFilterNames } from './helpers/switchTypes';

const useStyles = makeStyles((theme) => ({
  icon: {
    marginRight: theme.spacing(0.5),
    verticalAlign: 'middle',
  },
  iconOrg: {
    marginRight: theme.spacing(0.5),
    verticalAlign: 'middle',
  },
}));

interface Props {
  switchName: SwitchFilterNames;
  isWLNetPremium: boolean;
}

export const CustomSwitchTooltipTitle: React.FC<Props> = ({ switchName, isWLNetPremium }) => {
  const classes = useStyles();
  const { formatMessage } = useIntl();
  const mfwTheme = useMfwThemeProvider();

  switch (switchName) {
    case 'showMFWOriginals':
      return (
        <>
          <Box display="flex" alignItems="center">
            <StarIcon className={classes.icon} fontSize="inherit" color="primary" />
            <Typography variant="caption" color="primary">
              {formatMessage(contentMessages.show_wl_originals_filter_title, {
                name: mfwTheme.theme.whitelabel.name,
              })}
            </Typography>
          </Box>
          <Typography variant="body2">
            {formatMessage(contentMessages.show_wl_originals_filter, {
              name: mfwTheme.theme.whitelabel.name,
            })}
          </Typography>
        </>
      );

    case 'showORGOriginals':
      return (
        <>
          <Box display="flex" alignItems="center">
            <StarIcon className={classes.iconOrg} fontSize="inherit" color="secondary" />
            <Typography variant="caption" color="secondary">
              {formatMessage(pageMessages.org_content_title)}
            </Typography>
          </Box>
          <Typography variant="body2">
            {formatMessage(contentMessages.show_org_originals_filter)}
          </Typography>
        </>
      );

    case 'showPremium':
      return (
        <>
          <Typography color="inherit">
            {formatMessage(contentMessages.premium_filter_title, {
              netName: mfwTheme.theme.whitelabel.netName,
            })}
          </Typography>
          {formatMessage(contentMessages.premium_feed_filter, {
            netName: mfwTheme.theme.whitelabel.netName,
            name: mfwTheme.theme.whitelabel.name,
          })}
        </>
      );

    case 'showPublic': // NET!
      return (
        <>
          <Typography color="inherit">
            {
              formatMessage(contentMessages.public_feed_filter_title, {
                netName: mfwTheme.theme.whitelabel.netName,
              })
            }
          </Typography>
          {isWLNetPremium ?
            formatMessage(contentMessages.public_premium_feed_filter)
            :
            formatMessage(contentMessages.public_feed_filter, {
              netName: mfwTheme.theme.whitelabel.netName,
              name: mfwTheme.theme.whitelabel.name,
            })
          }
        </>
      );

    case 'isLockedContentDisplayed':
      return (
        <>
          <Typography color="inherit">
            {formatMessage(contentMessages.my_marketplace_content)}
          </Typography>
          {formatMessage(contentMessages.locked_content_info_message)}
        </>
      );

    case 'showMyMfwNet':
      return (
        <>
          <Typography color="inherit">
            {formatMessage(contentMessages.my_public_feed_filter_title, {
                netName: mfwTheme.theme.whitelabel.netName,
              })}
          </Typography>
          {isWLNetPremium ?
            formatMessage(contentMessages.my_public_premium_feed_filter,{
              netName: mfwTheme.theme.whitelabel.netName,
              name:mfwTheme.theme.whitelabel.name
            })
            :
            formatMessage(contentMessages.my_public_feed_filter, {
              netName: mfwTheme.theme.whitelabel.netName,
              name: mfwTheme.theme.whitelabel.name,
            })
          }
        </>
      );

    default:
      return null;
  }
};

export const CustomSwitchLabel: React.FC<Props> = ({ switchName, isWLNetPremium }) => {
  const { formatMessage } = useIntl();
  const mfwTheme = useMfwThemeProvider();

  switch (switchName) {
    case 'showMFWOriginals':
      return (
        <>
          {formatMessage(contentMessages.include_wl_content, {
            name: mfwTheme.theme.whitelabel.name,
          })}
        </>
      );

    case 'showORGOriginals':
      return (
        <>
          {formatMessage(contentMessages.show_org_originals)}
        </>
      );

    case 'showPremium':
      return (
        <b>Premium</b>
      );

    case 'showPublic':
      return (
        <b>
          {
            formatMessage(contentMessages.public_feed_filter_title, {
              netName: mfwTheme.theme.whitelabel.netName,
            })
          }
        </b>
      );

    case 'isLockedContentDisplayed':
      return (
        <b>{formatMessage(contentMessages.my_marketplace_content)}</b>
      );

    case 'showMyMfwNet':
      return (
        <b>
          {
            formatMessage(contentMessages.my_public_feed_filter_title, {
              netName: mfwTheme.theme.whitelabel.netName,
            })}
        </b>
      );

    default:
      return null;
  }
}
